import {
  Box,
  Card,
  ClickAwayListener,
  FormControlLabel,
  Stack,
  Typography,
  CircularProgress,
} from "@mui/material";
import AntSwitch from "../../sharedComponent/AntSwitch";
import phoneIcon from "../../../assets/images/icon/phoneIcon.svg";
import mailIcon from "../../../assets/images/icon/mailIcon.svg";
import threeDotsIcon from "../../../assets/images/icon/threedots.png";
import editIcon from "../../../assets/images/icon/edit.png";
import deleteIcon from "../../../assets/images/icon/delete.png";
import ProfileAvatar from "../../user/ProfileAvatar";
import { useState, useRef, useEffect } from "react";
import DownloadIcon from '@mui/icons-material/Download';
import InfoHoverTooltip from "../../Tooltips/InfoHover";
import { IconPhone } from '@tabler/icons-react';
import EmailIcon from "@mui/icons-material/Email";
import EditBlueIcon from "../../icons/EditBlueIcon";
interface Props {
  user: any;
  index?: number;
  // dropdownVisible: number | string | null,
  // setDropdownVisible: (a : any) => void,
  handleChangeSwitch: any;
  checked: any;
  openDeleteModal: any;
  openEditModal: any;
  allRoles?: any;
  // handleToggleDropdown: (a : any) => void,
  entityType?: string;
  handleDownloadLicense?: (partnerId: string) => void;
  isDownloading?: boolean;
}
const UserCardGrid = ({
  user,
  // dropdownVisible,
  // setDropdownVisible,
  handleChangeSwitch,
  checked,
  openDeleteModal,
  openEditModal,
  index,
  allRoles,
  entityType,
  handleDownloadLicense,
  isDownloading,
}: Props) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getRoleNameByProfileId = (id: number) => {
    let a = allRoles.find((role: any) => role.profileId === id);
    if (a) {
      return a.profileName;
    } else {
      return "N/A";
    }
  };

  return (
    <Card
      className="userCard"
      style={{
        opacity: user.accountStatus === "ACTIVE" ? "1" : "0.4",
      }}
    >
      <Stack display="flex" flexDirection="row" alignItems="start">
        <Box style={{ width: "100%" }}>
          <Stack
            display="flex"
            flexDirection="row"
            alignItems="start"
            justifyContent="space-between"
            style={{ marginBottom: "20px", position: "relative" }}
          >
            <Stack
              display="flex"
              flexDirection="row"
              alignItems="start"
              gap="8px"
            >
              {user.profilePhoto ? (
                <img
                  src={user.profilePhoto}
                  alt="partner"
                  className="icon"
                  height={52}
                  width={52}
                />
              ) : (
                <ProfileAvatar
                  firstName={user.name}
                  lastName={user.lastName !== undefined ? user.lastName : ""}
                />
              )}
              <div>
                <Typography className="userName">
                  <div
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      maxWidth: "130px",
                    }}
                    title={`${user.name} ${user.lastName !== undefined ? user.lastName : ""
                      }`}
                  >
                    {`${user.name} ${user.lastName !== undefined ? user.lastName : ""
                      }`}
                  </div>
                </Typography>
                <span className="bottom-box">
                  {getRoleNameByProfileId(user.profileId)}
                </span>
              </div>
            </Stack>

            <Stack flexDirection="row" alignItems="center">
              {/* Toggle switch — always shown */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingRight: "19px",
                  borderRight: user.accountStatus === "ACTIVE" ? "1px solid #313838" : undefined,
                  margin: "3px 0px",
                  opacity: 1,
                }}
              >
                <FormControlLabel
                  control={
                    <AntSwitch checked={checked} onChange={handleChangeSwitch} />
                  }
                  labelPlacement="start"
                  label={<Typography> </Typography>}
                />
              </Box>

              {entityType === "technicians" ? (
                /* ─── TECHNICIANS: hamburger ─── */
                user.accountStatus === "ACTIVE" && (
                  <div ref={dropdownRef} style={{ position: "relative" }}>
                    <img
                      className="icon"
                      src={threeDotsIcon}
                      alt="options"
                      style={{ marginLeft: "5px", cursor: "pointer" }}
                      onClick={() => setDropdownOpen((v) => !v)}
                    />
                    {dropdownOpen && (
                      <div
                        className="cardDropdown"
                        style={{ top: "24px", right: 0, minWidth: "130px", position: "absolute", zIndex: 10 }}
                      >
                        <Stack
                          flexDirection="row"
                          alignItems="center"
                          gap="4px"
                          style={{ padding: "8px", cursor: "pointer" }}
                          onClick={() => { openEditModal(user.userId); setDropdownOpen(false); }}
                        >
                          <img src={editIcon} alt="edit Icon" />
                          <Typography>Edit</Typography>
                        </Stack>
                        <Stack
                          flexDirection="row"
                          alignItems="center"
                          gap="4px"
                          style={{ padding: "8px", cursor: "pointer" }}
                          onClick={() => { openDeleteModal(); setDropdownOpen(false); }}
                        >
                          <img src={deleteIcon} alt="delete Icon" />
                          <Typography>Delete</Typography>
                        </Stack>
                      </div>
                    )}
                  </div>
                )
              ) : (
                /* ─── DISTRIBUTORS / PARTNERS: inline icons ─── */
                <>
                  {/* <img
                    src={'/icons/edit-blue-icon.svg'}
                    alt="Edit User"
                    onClick={() => openEditModal(user.userId)}
                    style={{ marginLeft: "5px", width: "20px", cursor: "pointer" }}
                  /> */}
                  {entityType === "distributors" && (
                    <>
                      <div
                        className="vertical-divider"
                        style={{
                          borderRight: "1px solid #313838",
                          paddingRight: "5px",
                          height: "16px",
                          marginTop: "3px",
                        }}
                      />
                      <InfoHoverTooltip title={isDownloading ? "Downloading..." : "Download license key"} arrowDirection="bottom">
                        <Box component="span" sx={{ display: "inline-flex", alignItems: "center" }}>
                          {isDownloading ? (
                            <CircularProgress size={20} sx={{ color: "#17b2eb", marginTop: "2px", marginLeft: "5px" }} />
                          ) : (
                            <DownloadIcon
                              sx={{
                                color: "#17b2eb !important",
                                fontSize: 24,
                                stroke: "#17b2eb",
                                fill: "#17b2eb",
                                marginLeft: "5px",
                                marginTop: "2px",
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                              }}
                              onClick={() => handleDownloadLicense?.(user.userId)}
                            />
                          )}
                        </Box>
                      </InfoHoverTooltip>
                    </>
                  )}
                </>
              )}
            </Stack>
          </Stack>
          <div className="userDetails" style={{ marginLeft: "58px" }}>
            {/* <img src={phoneIcon} alt="phone" /> */}
            <IconPhone stroke={1.8} color="#B4B7B8" size={17}/>
            <div style={{ maxWidth: "150px" }} className="textEllipsis">
              {user.mobile}
            </div>
          </div>
          <div className="userDetails" style={{ marginLeft: "58px" }}>
            {/* <img src={mailIcon} alt="mail" /> */}
             <EmailIcon
                 sx={{
                   fontSize: "17px",
                   color: "#B4B7B8",
                }}
              />
            <div
              style={{
                maxWidth: "150px",
                cursor: "pointer",
              }}
              className="textEllipsis"
              title={user.mailId}
            >
              {user.mailId}
            </div>
          </div>
        </Box>
      </Stack>
    </Card>
  );
};

export default UserCardGrid;
